// underEyeFillersData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const underEyeFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Best Under Eye Fillers in Dubai by Expert Dermatologists",
            "description": "Get the best under eye fillers in Dubai, a popular cosmetic treatment with Juvederm and hyaluronic acid to smooth under-eye bags, dark circles, & fill hollows.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/under-eye-fillers-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Best Under Eye Fillers in Dubai by Expert Dermatologists",
                "description": "Get the best under eye fillers in Dubai, a popular cosmetic treatment with Juvederm and hyaluronic acid to smooth under-eye bags, dark circles, & fill hollows.",
                "url": "https://elitebodyhome.com/services/under-eye-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:40:26+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-98.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-98.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "Under Eye Fillers",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Best Under Eye Fillers in Dubai by Expert Dermatologists",
                "description": "Get the best under eye fillers in Dubai, a popular cosmetic treatment with Juvederm and hyaluronic acid to smooth under-eye bags, dark circles, & fill hollows.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-98.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Under Eye Fillers Dubai"],
        "hero": {
            "title": "Under Eye Fillers Dubai",
            "subtitle": "Restore Youthful Eyes with Under Eye Fillers",
            "description": "Our Under Eye Fillers procedure at Elite Body Home is a secure and efficient way to give you back young, rested eyes. By providing volume and smoothness to the sensitive area beneath the eyes, this non-surgical process, which is intended to address fine lines, dark circles, and hollow under-eyes, quickly revitalizes your appearance. To help you look and feel your best, our skilled professionals employ high-quality, FDA-approved fillers to guarantee natural-looking results with little recovery time. With Elite Body Home's customized approach to under-eye rejuvenation, you can rediscover a more radiant and brighter version of yourself."
        },
        "howItWorks": {
            "title": "How Do Under Eye Fillers Work?",
            "description": "A cutting-edge cosmetic procedure called under-eye fillers is intended to revitalize and revitalize the sensitive area beneath the eyes. Dermal fillers, which are mostly made of hyaluronic acid, can be precisely injected into the under-eye area to decrease dark circles, diminish fine wrinkles, and efficiently restore lost volume."
        },
        "procedureSteps": {
            "heading": "Steps For Under Eye Fillers Treatment Procedure",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "During your consultation, a skilled practitioner will assess your under-eye area and discuss your aesthetic goals to ensure fillers are the right treatment for you.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "Preparation",
                    "desc": "Before the procedure, a numbing cream is applied to the under-eye region to ensure your comfort.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "Injections",
                    "desc": "Using a fine needle or cannula, the filler is carefully injected into targeted areas under the eyes to add volume and smooth the skin.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Immediate Results",
                    "desc": "You will notice an instant improvement, with full results becoming visible after any minor swelling subsides, usually within a few days.",
                    "icon": "fa-regular fa-eye"
                }
            ]
        },
        "benefits": {
            "heading": "Key Benefits of Under Eye Fillers",
            "subheading": "A simple, non-surgical way to revitalize the sensitive area under your eyes is with under eye fillers.",
            "para": "They give the appearance of renewed youth by reducing fine wrinkles and restoring volume. These are the main advantages:",
            "items": [
                {
                    "title": "Instant Outcomes",
                    "desc": "Experience a noticeable improvement immediately following treatment, with complete benefits showing up a few days later.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Diminish Dark Circles",
                    "desc": "Fillers lessen the visibility of dark shadows beneath the eyes and smooth out hollows.",
                    "icon": "fa-regular fa-circle"
                },
                {
                    "title": "Wrinkles & Fine Lines Are Smooth",
                    "desc": "Fillers provide the under-eye area a more young, refreshed appearance by reducing the appearance of fine wrinkles.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "Minimally Invasive & Non-Surgical",
                    "desc": "There is little to no healing time, no discomfort, and no need for surgery after the operation.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Enhancement That Looks Natural",
                    "desc": "Without significantly changing your appearance, the results are modest and natural, giving you a more rested appearance.",
                    "icon": "fa-regular fa-face-grin"
                },
                {
                    "title": "Prolonged Impacts",
                    "desc": "Under-eye fillers are a long-lasting and efficient option, with results usually lasting 9 to 12 months.",
                    "icon": "fa-solid fa-hourglass"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility for Under Eye Fillers",
            "subheading": "The following are the main determinants of treatment eligibility:",
            "para": "",
            "items": [
                {
                    "title": "Dark circles or hollows that are visible",
                    "desc": "Fillers can assist restore brightness and volume if you have dark circles under your eyes that don't go away or if you have hollowing under your eyes that makes you look exhausted.",
                    "icon": "fa-regular fa-eye"
                },
                {
                    "title": "Dark circles that are mild to moderate",
                    "desc": "Under-eye fillers can help people with dark circles that are not caused by pigmentation but rather by shadowing from volume loss.",
                    "icon": "fa-solid fa-moon"
                },
                {
                    "title": "Good Skin Health",
                    "desc": "In the treatment area, candidates should have skin that is typically healthy and free of any active infections or skin disorders.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "No Excruciating Allergies",
                    "desc": "The treatment is thought to be appropriate for people who have never experienced serious adverse responses to the chemicals in dermal fillers.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "Not nursing or pregnant",
                    "desc": "It is not advised for people who are pregnant or nursing to get under eye fillers.",
                    "icon": "fa-solid fa-baby"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "You can get the most out of your under-eye filler treatment by being well-prepared.",
            "para": "The following are essential actions to take before to your procedure:",
            "items": [
                {
                    "title": "Consultation",
                    "desc": "Make an appointment for a consultation with a skilled professional to go over your objectives, assess the region under your eyes, and choose the best filler for you.",
                    "icon": "fa-regular fa-calendar-check"
                },
                {
                    "title": "Steer clear of blood-thinning drugs.",
                    "desc": "Blood-thinning drugs like aspirin, ibuprofen, and supplements like vitamin E and fish oil should be avoided for approximately a week before to the treatment because they can make bruising more likely.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Limit Your Alcohol Use",
                    "desc": "Because alcohol thins the blood and increases the risk of swelling or bruising, avoid drinking it for 24 to 48 hours before your appointment.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "Stay hydrated and get some rest.",
                    "desc": "Your body will react better to the therapy and recover more quickly if you drink lots of water and get lots of sleep before your session.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "Avoid Topical Skin Care Products",
                    "desc": "To reduce skin sensitivity, refrain from applying abrasive exfoliants, retinoids, or other skin treatments to the area beneath your eyes a few days prior to your procedure.",
                    "icon": "fa-solid fa-bottle-droplet"
                },
                {
                    "title": "Show up with a fresh face.",
                    "desc": "To ensure a clean, sterile treatment area on the day of your surgery, make sure your face is clear of lotions, creams, and makeup.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "Under eye fillers deliver noticeable improvements with minimal downtime.",
            "para": "Here's what you can expect after your treatment:",
            "items": [
                {
                    "title": "Immediate Results",
                    "desc": "You'll see a visible reduction in hollows and dark circles right after the procedure. The under-eye area will appear fuller and more youthful.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Full Results in a Few Days",
                    "desc": "While initial results are noticeable immediately, minor swelling or bruising may occur. Full results typically settle in after a few days as the filler integrates with your skin.",
                    "icon": "fa-solid fa-calendar-day"
                },
                {
                    "title": "Natural-Looking Enhancement",
                    "desc": "The under-eye area will look naturally refreshed, not overdone. Fillers smooth out fine lines and restore volume, giving you a brighter, well-rested appearance.",
                    "icon": "fa-regular fa-face-smile-beam"
                },
                {
                    "title": "Long-Lasting Effects",
                    "desc": "Results generally last 9 to 12 months, depending on the type of filler used and individual factors like metabolism and lifestyle.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Minimal Downtime",
                    "desc": "Most people can return to their regular activities immediately after the procedure, though some mild swelling or bruising might last for a few days.",
                    "icon": "fa-solid fa-business-time"
                },
                {
                    "title": "Gradual Dissipation",
                    "desc": "Over time, the filler will naturally break down and be absorbed by the body. You can opt for touch-ups as needed to maintain your results.",
                    "icon": "fa-solid fa-arrows-down-to-line"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long do under-eye fillers last?",
                    "answer": "Under-eye fillers typically last between 9 to 12 months, depending on individual factors such as metabolism, lifestyle, and the specific type of filler used."
                },
                {
                    "question": "Is the procedure painful?",
                    "answer": "The procedure is generally well-tolerated. A topical numbing cream is applied before the treatment to minimize discomfort, and most patients report only mild sensations during the injections."
                },
                {
                    "question": "How soon will I see results?",
                    "answer": "You'll notice an immediate improvement right after the procedure, with full results appearing within a few days once any minor swelling or bruising subsides."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Some mild swelling, bruising, or redness can occur around the injection site, but these effects usually resolve within a few days. Serious complications are rare when performed by a qualified practitioner."
                },
                {
                    "question": "How do I prepare for the treatment?",
                    "answer": "Avoid alcohol, blood-thinning medications, and strenuous exercise 24 hours before treatment. Your provider will give specific guidelines during your consultation."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/New-Service-Banner-Image-8-1-scaled.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botox-in-dubai-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botox-in-dubai-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/full-face-botox-in-dubai-3.jpg"
            ]
        },
        "product": {
            "id": 116,
            "title": "Under Eye Fillers (Tear Trough Treatment)",
            "price": 599,
            "description": "Under eye fillers are injectable treatments using hyaluronic acid-based products like Juvederm to fill hollows, reduce puffiness, and brighten dark circles under the eyes. Safe and effective for a refreshed, youthful appearance."
        },
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "أفضل فيلر تحت العين في دبي من قبل أطباء الجلدية الخبراء",
            "description": "احصل على أفضل فيلر تحت العين في دبي، علاج تجميلي شائع باستخدام جوفيديرم وحمض الهيالورونيك لتخفيف الانتفاخات تحت العين، الهالات السوداء، وملء الفراغات.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/under-eye-fillers-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "أفضل فيلر تحت العين في دبي من قبل أطباء الجلدية الخبراء",
                "description": "احصل على أفضل فيلر تحت العين في دبي، علاج تجميلي شائع باستخدام جوفيديرم وحمض الهيالورونيك لتخفيف الانتفاخات تحت العين، الهالات السوداء، وملء الفراغات.",
                "url": "https://elitebodyhome.com/services/under-eye-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2024-12-30T10:40:26+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-98.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-98.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "فيلر تحت العين",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "أفضل فيلر تحت العين في دبي من قبل أطباء الجلدية الخبراء",
                "description": "احصل على أفضل فيلر تحت العين في دبي، علاج تجميلي شائع باستخدام جوفيديرم وحمض الهيالورونيك لتخفيف الانتفاخات تحت العين، الهالات السوداء، وملء الفراغات.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-98.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر تحت العين دبي"],
        "hero": {
            "title": "فيلر تحت العين دبي",
            "subtitle": "استعد شباب عينيك مع فيلر تحت العين",
            "description": "يُعد فيلر تحت العين في ايليت بودي هوم إجراءً آمنًا وفعالًا يمنح عينيكِ مظهرًا أكثر شبابًا وحيوية. يعمل هذا الإجراء غير الجراحي على إضافة امتلاءً ونعومة لمنطقة تحت العين، مما يساعد في التخلص من الخطوط الدقيقة، والهالات السوداء، والتجويف تحت العين، ليمنحكِ إطلالة أكثر إشراقًا وانتعاشًا في وقت قصير. يستخدم فريقنا المتخصص فيلر عالي الجودة ومعتمد من إدارة الغذاء والدواء الأمريكية (FDA) لضمان نتائج طبيعية تدوم طويلًا، مع فترة التعافي قصيرة جدًا. استمتعي بإطلالة مشرقة وأكثر حيوية مع علاج ايليت بودي هوم المخصص لتجديد منطقة تحت العين، واكتشفي نسخة أكثر إشراقًا من نفسك!"
        },
        "howItWorks": {
            "title": "كيف يعمل فيلر تحت العين؟",
            "description": "يُعد فيلر تحت العين إجراءً تجميليًا متطورًا مصممًا لتجديد وإعادة الحيوية لمنطقة تحت العين. تعتمد هذه التقنية على حقن الفيلر المكون من حمض الهيالورونيك بدقة في منطقة تحت العين للمساعدة في التخفيف من الهالات السوداء، وتقليل التجاعيد الدقيقة، واستعادة حجم الوجه المفقود بفعالية."
        },
        "procedureSteps": {
            "heading": "خطوات إجراء فيلر تحت العين",
            "para": "",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "سيقوم الطبيب المتخصص خلال جلسة الاستشارة بتقييم منطقة تحت العين لديك ومناقشة أهدافك التجميلية لضمان أن الفيلر هو العلاج المناسب لك.",
                    "icon": "fa-regular fa-comment-dots"
                },
                {
                    "title": "الاستعداد",
                    "desc": "يُستخدم كريم مخدر على منطقة تحت العين قبل الإجراء لضمان راحتك أثناء الجلسة.",
                    "icon": "fa-regular fa-hand-sparkles"
                },
                {
                    "title": "الحقن",
                    "desc": "يتم حقن الفيلر بعناية في المناطق المستهدفة تحت العين باستخدام إبرة أو قنية دقيقة لإضافة حجم للوجه وتنعيم البشرة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "نتائج فورية",
                    "desc": "ستلاحظ تحسنًا فوريًا، بينما تظهر النتائج الكاملة بعد زوال الانتفاخ خلال بضعة أيام.",
                    "icon": "fa-regular fa-eye"
                }
            ]
        },
        "benefits": {
            "heading": "مزايا فيلر تحت العين",
            "subheading": "يُعد فيلر تحت العين حل غير جراحي بسيط لتجديد منطقة تحت العين.",
            "para": "يمنحك مظهرًا متجددًا وأكثر شبابًا من خلال تقليل الخطوط الدقيقة واستعادة حجم البشرة. إليك الفوائد الرئيسية:",
            "items": [
                {
                    "title": "نتائج فورية",
                    "desc": "ستلاحظ تحسنًا فوريًا بعد العلاج، مع ظهور النتائج النهائية بعد بضعة أيام.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تقليل الهالات السوداء",
                    "desc": "يساعد الفيلر في تقليل مظهر الظلال الداكنة تحت العينين وتعبئة التجاويف.",
                    "icon": "fa-regular fa-circle"
                },
                {
                    "title": "تنعيم التجاعيد والخطوط الدقيقة",
                    "desc": "يمنح مظهرًا أكثر شبابًا وانتعاشًا لمنطقة تحت العين، من خلال تقليل التجاعيد الدقيقة.",
                    "icon": "fa-solid fa-face-smile"
                },
                {
                    "title": "إجراء غير جراحي",
                    "desc": "لا يتطلب تدخل جراحي أو فترة تعافي تُذكر، كما لا يسبب ألم بعد الإجراء.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "تحسين طبيعي لملامح الوجه",
                    "desc": "تُعد النتائج طفيفة وطبيعية، مما يمنحك إطلالة أكثر راحة وحيوية دون تغيير ملامحك.",
                    "icon": "fa-regular fa-face-grin"
                },
                {
                    "title": "نتائج تدوم طويلاً",
                    "desc": "تستمر نتائج فيلر تحت العين ما بين 9 إلى 12 شهرًا عادةً، مما يجعله علاجًا فعالًا وطويل الأمد.",
                    "icon": "fa-solid fa-hourglass"
                }
            ]
        },
        "eligibility": {
            "heading": "المرشح المناسب لفيلر تحت العين",
            "subheading": "يلائم علاج فيلر تحت العين الأشخاص التالية:",
            "para": "",
            "items": [
                {
                    "title": "الهالات السوداء أو تجويف تحت العين",
                    "desc": "إذا كنت تعاني من هالات تحت العين لا تزول أو تجويف يجعل مظهرك مرهقًا، يمكن للفيلر المساعدة في استعادة حجم البشرة ومنحها مظهرًا أكثر إشراقًا.",
                    "icon": "fa-regular fa-eye"
                },
                {
                    "title": "الهالات السوداء بدرجة خفيفة إلى متوسطة",
                    "desc": "يناسب الفيلر الأشخاص الذين يعانون من الهالات الناتجة عن فقدان حجم الوجه وليس بسبب التصبغات.",
                    "icon": "fa-solid fa-moon"
                },
                {
                    "title": "بشرة صحية",
                    "desc": "يجب أن يكون الجلد في المنطقة المعالجة صحيًا وخاليًا من الالتهابات أو المشكلات الجلدية النشطة.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "عدم وجود حساسية شديدة",
                    "desc": "يناسب من لم يسبق لهم التعرض لردود فعل تحسسية خطيرة تجاه مكونات الفيلر.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "غير حامل أو مرضعة",
                    "desc": "لا يُنصح بالخضوع للعلاج أثناء الحمل أو الرضاعة.",
                    "icon": "fa-solid fa-baby"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد لفيلر تحت العين",
            "subheading": "يُنصح بالتحضير الجيد قبل الجلسة، لضمان تحقيق أفضل النتائج.",
            "para": "إليك أهم الخطوات التي يجب اتباعها:",
            "items": [
                {
                    "title": "الاستشارة",
                    "desc": "احجز موعدًا مع أحد الخبراء المتخصصين لمناقشة أهدافك، وتقييم منطقة تحت العين، واختيار الفيلر الأنسب لك.",
                    "icon": "fa-regular fa-calendar-check"
                },
                {
                    "title": "تجنب الأدوية المميعة للدم",
                    "desc": "امتنع عن تناول الأدوية المسيلة للدم مثل الأسبرين والإيبوبروفين، بالإضافة إلى المكملات الغذائية مثل فيتامين E وزيت السمك، لمدة أسبوع قبل الجلسة للحد من خطر الكدمات.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الامتناع عن شرب الكحول",
                    "desc": "تجنب شرب الكحول لمدة 24 إلى 48 ساعة قبل الجلسة، لأنه قد يزيد من احتمالية التورم أو الكدمات.",
                    "icon": "fa-solid fa-wine-glass-empty"
                },
                {
                    "title": "الحفاظ على الترطيب والراحة",
                    "desc": "يساعد شرب كميات كافية من الماء والحصول على قسط كافٍ من النوم على تحسين استجابة الجسم للعلاج وتسريع عملية التعافي.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "الامتناع عن منتجات العناية بالبشرة",
                    "desc": "يُفضل تجنب استخدام المقشرات القاسية، أو الريتينويدات، أو أي منتجات قوية على البشرة في منطقة تحت العين قبل عدة أيام من الجلسة لتقليل حساسية الجلد.",
                    "icon": "fa-solid fa-bottle-droplet"
                },
                {
                    "title": "الحضور ببشرة نظيفة",
                    "desc": "تأكد من أن وجهك خالي من المكياج، أو الكريمات، أو أي منتجات أخرى في يوم الجلسة لضمان بيئة علاجية معقمة.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                }
            ]
        },
        "results": {
            "heading": "نتائج فيلر تحت العين",
            "subheading": "يمنحك فيلر تحت العين تحسنًا ملحوظًا مع فترة تعافي قصيرة جدًا.",
            "para": "إليك ما يمكنك توقعه بعد العلاج:",
            "items": [
                {
                    "title": "نتائج فورية",
                    "desc": "ستلاحظ امتلائًا واضحًا للتجاويف وتحسنًا ملحوظ في الهالات السوداء فور الانتهاء من الجلسة، حيث ستبدو منطقة تحت العين أكثر امتلاءً ونضارة.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "تحسن تدريجي خلال أيام",
                    "desc": "رغم أن النتائج الأولية تظهر على الفور، ولكن قد يحدث تورم طفيف أو كدمات مؤقتة، وتستقر النتائج النهائية بعد بضعة أيام مع اندماج الفيلر بالبشرة.",
                    "icon": "fa-solid fa-calendar-day"
                },
                {
                    "title": "نتائج طبيعية",
                    "desc": "تمنحك حقن الفيلر مظهرًا منتعشًا دون مبالغة، حيث تعمل على تنعيم الخطوط الدقيقة واستعادة حجم الوجه المفقود، مما يمنحك إطلالة مشرقة وأكثر راحة.",
                    "icon": "fa-regular fa-face-smile-beam"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تدوم النتائج بين 9 إلى 12 شهرًا عادةً، وذلك حسب نوع الفيلر المستخدم والعوامل الفردية مثل معدل الأيض ونمط الحياة.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "لا يتطلب فترة تعافي",
                    "desc": "يمكن لمعظم الأشخاص العودة إلى أنشطتهم اليومية فورًا بعد الجلسة، مع احتمال حدوث انتفاخ خفيف أو كدمات لبضعة أيام فقط.",
                    "icon": "fa-solid fa-business-time"
                },
                {
                    "title": "ذوبان الفيلر تدريجيًا",
                    "desc": "يذوب الفيلر بشكل طبيعي بمرور الوقت ويتم امتصاصه من قبل الجسم، ويمكنك إجراء جلسات متابعة للحفاظ على النتائج وفقًا لرغبتك.",
                    "icon": "fa-solid fa-arrows-down-to-line"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": "fa-solid fa-water"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تدوم نتائج فيلر تحت العين؟",
                    "answer": "عادةً ما تدوم نتائج فيلر تحت العين بين 9 إلى 12 شهرًا، اعتمادًا على عوامل فردية مثل معدل الأيض ونمط الحياة ونوع الفيلر المستخدم."
                },
                {
                    "question": "هل الإجراء مؤلم؟",
                    "answer": "يتم تطبيق كريم مخدر قبل العلاج لتقليل الانزعاج، ويشعر معظم المرضى بإحساس خفيف فقط أثناء الحقن."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "ستلاحظ تحسنًا فوريًا بعد الإجراء مباشرة، مع ظهور النتائج الكاملة خلال بضعة أيام بعد زوال أي تورم أو كدمات طفيفة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "قد يحدث تورم خفيف أو كدمات أو احمرار حول موقع الحقن، ولكن هذه الآثار تختفي عادةً خلال بضعة أيام. نادرًا ما تحدث مضاعفات خطيرة عند إجراء العلاج من قبل أخصائي مؤهل."
                },
                {
                    "question": "كيف أستعد للعلاج؟",
                    "answer": "تجنب الكحول والأدوية المميعة للدم والتمارين الشاقة قبل 24 ساعة من العلاج. سيقدم لك المزود إرشادات محددة خلال استشارتك."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []

    }
};
